import React from 'react'
import {TertiaryButtonDark} from '../../../../core/components/unilink/index'

const NotificationSettings = () => {

  return (
    <div className='edit-profile__content'>
      <div className='notification-settings'>
        <div className='edit-profile__block'>
          <h1 className='edit-profile__block-title'>Email notifications</h1>
          <div className='edit-profile__input-container'>
            <span className='edit-profile__text'>
              Do you want to receive emails from Expii? You will always receive important notifications such as password resets.
            </span>
            <TertiaryButtonDark className='edit-profile__button' disabled>
              Turn off notifications
            </TertiaryButtonDark>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotificationSettings



// WEBPACK FOOTER //
// ./src/domains/user/edit-profile/components/NotificationsSettings.js